import { z } from "zod";

export const PermissionGroupsSearchParamsSchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  search: z.string().optional(),
});

export type PermissionGroupsSearchParams = z.infer<
  typeof PermissionGroupsSearchParamsSchema
>;
